
import { Component, Prop, Vue } from 'vue-property-decorator';
import SvgPopup from '@/components/Svg/SvgPopup.vue';
import { reconcileAccount } from '@/api/resources/ssoApi';
import { loginAndRedirectToLanding } from '@/services/authSpace/sso.service';

@Component({
  components: {
    SvgPopup,
  },
})
export default class NeedToReconcileDialog extends Vue {
  @Prop({
    type: Object,
    required: false,
  })
  readonly userInfos!: any;

  snackbar = false;

  snackbarMessage = '';

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.xsOnly;
  }

  showSnackBar(message: string) {
    this.snackbarMessage = message;
    this.snackbar = true;
  }

  async handleAcceptReconciliate() {
    const userData = this.$store.getters['user/getReconcileData'];
    const reconcile = await reconcileAccount({ userInfos: userData.userInfos, platformUUID: userData.platformUUID });
    this.$store.dispatch('showNeedToReconcileMessage', false);
    return loginAndRedirectToLanding(reconcile.tokens);
  }
}
